import React, { Children, cloneElement, useCallback, useEffect, useState } from 'react'

import PropTypes from 'prop-types'

const setRef = (ref, value) => {
  if (typeof ref === 'function') {
    ref(value)
  } else if (ref) {
    ref.current = value
  }
}

const rootPropType = typeof Element === 'undefined' ? PropTypes.any : PropTypes.instanceOf(Element)

const IntersectionObserver = ({
  children,
  disabled,
  onChange,
  root,
  rootMargin,
  threshold,
}) => {
  const child = Children.only(children)
  const [node, setNode] = useState(null)

  const handleRef = useCallback(value => {
    setNode(value)
    setRef(child.ref, value)
  }, [child.ref])

  useEffect(() => {
    if (disabled || !node || typeof window === 'undefined' || !window.IntersectionObserver) return

    const observer = new window.IntersectionObserver(([entry]) => {
      entry && onChange?.(entry)
    }, {
      root,
      rootMargin,
      threshold,
    })

    observer.observe(node)

    return () => observer.disconnect()
  }, [disabled, node, onChange, root, rootMargin, threshold])

  return cloneElement(child, { ref: handleRef })
}

IntersectionObserver.propTypes = {
  children: PropTypes.element.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  root: rootPropType,
  rootMargin: PropTypes.string,
  threshold: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
}

IntersectionObserver.defaultProps = {
  disabled: false,
  onChange: undefined,
  root: null,
  rootMargin: '0px',
  threshold: 0,
}

export default IntersectionObserver
